import { useTranslation } from 'react-i18next';
import { StyledButton } from '../ui';
import { SpecialPackageOccupancy } from './occupancy';

export interface ISpecialPackageOccupancyPickerProps {
  availableOccupancies: SpecialPackageOccupancy[];
  selectedOccupancy: number | null | undefined;
  onChange: (occupancy: SpecialPackageOccupancy) => void;
}

export function SpecialPackageOccupancyPicker(
  props: ISpecialPackageOccupancyPickerProps
) {
  const { t } = useTranslation('offer-package');

  if (props.availableOccupancies.length <= 1) {
    return null;
  }

  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {props.availableOccupancies.map((occupancy) => (
        <StyledButton
          key={occupancy}
          type="button"
          design={props.selectedOccupancy === occupancy ? 'primary' : 'default'}
          rootClassName="w-full"
          className="w-full justify-center shrink-0 text-nowrap"
          onClick={() => props.onChange(occupancy)}
        >
          {t(
            occupancy === 1
              ? 'special.shared.one-person'
              : 'special.shared.two-persons'
          )}
        </StyledButton>
      ))}
    </div>
  );
}

export default SpecialPackageOccupancyPicker;
